<template>
    <div class="servicePoints">
        <h3>{{languageStrings['Servicepoints Anzeigen']}}</h3>
        <div class="points">
            <router-link :to="{name: 'Services', params: { id:'servicepoint', type: 'toilet' }}">
                <service-point  :type="'toilet'" :position="{x:0,y:0}"></service-point>
            </router-link>
            <router-link :to="{name: 'Services', params: { id:'servicepoint', type: 'info' }}">
                <service-point  :type="'info'" :position="{x:0,y:0}"></service-point>
            </router-link>
            <router-link :to="{name: 'Services', params: { id:'servicepoint', type: 'bank' }}">
                <service-point :type="'bank'" :position="{x:0,y:0}"></service-point>
            </router-link>
            <router-link :to="{name: 'Services', params: { id:'servicepoint', type: 'lock' }}" >
                <service-point :type="'lock'" :position="{x:0,y:0}"></service-point>
            </router-link>
            <router-link :to="{name: 'Services', params: { id:'servicepoint', type: 'lift' }}" >
                <service-point :type="'lift'" :position="{x:0,y:0}"></service-point>
            </router-link>
          <router-link :to="{name: 'Services', params: { id:'servicepoint', type: 'parkdeck' }}" >
            <service-point :type="'parkdeckmain'" :position="{x:0,y:0}"></service-point>
          </router-link>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "@/styles/variables";
.servicePoints {

    h3 {
        color: #707070;
        font-size: 24px;
    }

    .points {
        display: flex;
    }

    a {
        @include buttonActive;
    }
    .service-point {
        position: relative;
        margin-right: 10px;
        width: 77px;
    }

    @include portrait(){
        left: 490px;
        width: 270px;
        flex-wrap: wrap;
        bottom: 65px;
    }

}
</style>

<script>
import ServicePoint from '@/components/ServicePoint.vue'

export default {
    name: 'ServicePoints',
    data() {
        return {
            // types: ['lift', 'bank', 'toilet', 'info', 'lock'],
            // currentType: ''
        }
    },
    created() {
        // this.currentType = this.type
    },
    components: {
        ServicePoint
    },
    props:['type', 'position', 'dataid', 'languageStrings'],

}
</script>